import ComplianceTemplate from '@components/templates/ComplianceTemplate/ComplianceTemplate'
import { initializeApollo } from '@gql/client'
import useTrans from '@hooks/useTrans'
import { NextWrapper } from 'data-fetching-wrapper'
import { PAGINA } from 'utils/queries'
import { PaginaType } from 'utils/types'

interface Props {
  pagina: PaginaType
}

function Page({ pagina }: Props) {
  const t = useTrans()

  return (
    <ComplianceTemplate pagina={pagina}>
      <div id={t('cookiebot_container')} />
    </ComplianceTemplate>
  )
}

export const getServerSideProps = NextWrapper.getServerSideProps(async ({ req }) => {
  const headers = req?.headers?.cookie ? { cookie: req.headers.cookie } : {}

  const client = initializeApollo()

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { path: '/cookie-policy' },
    context: {
      headers,
    },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      pagina,
      key: pagina.pk,
    },
  }
})

export default Page
